export default {"src":"/_next/static/media/ball-icon.ad5175ef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};